import { Factory } from 'rosie';

Factory.define('UsersAdmin').attr('name', 'USERS_ADMIN');

Factory.define('UsersAdminWithDefaults').extend('UsersAdmin');
